import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
    calculateDiscountedPrice,
    calculateDiscountPercentage,
    calculateTimeUntilEndOfYear,
    sortData
} from '../Helper/Calculation';
import {
    fetchAllSubjectData,
    fetchEnrollCourses,
    fetchEnrollUnit,
    fetchUnitData,
    getEnrolledDocRef,
    saveCourseData
} from '../Firebase/Course-fb';
import {
    getCurrentUserDetail,
    getUserDocId,
    isLoggedIn
} from '../Localstorage';
import { getDoc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useAccessCard } from '../ContextProvider/Accesscardprovider';
import logo from '../Images/Logo/bbarna.png'

const Featured = () => {
    const [subject, setSubject] = useState([]);
    const [loading, setLoading] = useState(true);
    const [payingId, setPayingId] = useState(null);
    const navigate = useNavigate();
    const { accessCard, accessCallReg, enroll, setEnrolData, setToast } = useAccessCard();
    const [loginState, setLoginState] = useState(isLoggedIn());

    // Track login/logout
    useEffect(() => {
        const interval = setInterval(() => {
            const currentStatus = isLoggedIn();
            setLoginState(currentStatus);
        }, 1000); // check every 1s

        return () => clearInterval(interval);
    }, []);

    // Load subjects + enrolled courses
    useEffect(() => {
        const getPopularSubjects = async () => {
            setLoading(true);
            try {
                if (loginState) {
                    const userId = await getUserDocId();
                    const enrollData = await fetchEnrollCourses(userId);
                    setEnrolData(enrollData[0]?.course_list || []);
                } else {
                    setEnrolData([]); // clear on logout
                }

                const allSubjects = await fetchAllSubjectData();
                const popularSubjects = allSubjects.filter(sub => sub.isPopular === true);
                setSubject(popularSubjects);
            } catch (error) {
                console.error("Failed to fetch subjects:", error);
            } finally {
                setLoading(false);
            }
        };

        getPopularSubjects();
    }, [loginState]);

    const showToast = (msg, type) => {
        setToast({ message: msg, type });
    };

    const handlePayment = async (event, item) => {
        event.preventDefault();
        const isLogin = isLoggedIn();
        if (isLogin) {
            setPayingId(item.subject_code);
            const getUserId = await getUserDocId();
            const user = getCurrentUserDetail()[0];

            const enrolData = {
                access_till: calculateTimeUntilEndOfYear(),
                access_type: "PAID",
                subject_code: item.subject_code,
                subject_image: item.subject_image,
                subject_name: item.subject_name,
                unit_code_list: []
            };

            const course = {
                course_list: [enrolData],
                student_id: getUserId,
                student_name: user.name
            };

            const res = await fetch(
                "https://us-central1-bbarna-6a725.cloudfunctions.net/createRazorpayOrder",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ amount: (item.selling_price || item.subject_price) })
                }
            );

            const data = await res.json();
            console.log("order id = ", data.id)

            const options = {
                key: "rzp_live_ALbX7RKvJAGMtR",
                amount: (item.selling_price || item.subject_price) * 100,
                currency: "INR",
                name: "B_BARNA",
                description: "Course Payment",
                order_id: data.id,
                image: logo,
                handler: async function (response) {
                    try {
                        const docRef = await getEnrolledDocRef(getUserId);

                        if (docRef) {
                            const docSnap = await getDoc(docRef);

                            if (docSnap.exists()) {
                                const existingData = docSnap.data();
                                const updatedCourseList = [...existingData.course_list, enrolData];
                                await updateDoc(docRef, { course_list: updatedCourseList });
                            } else {
                                console.log("No enrolled document found for this user!");
                            }
                        } else {
                            await saveCourseData(course);
                        }

                        const enrolled = await fetchEnrollCourses(getUserId);
                        setEnrolData(enrolled[0]?.course_list || []);

                    } catch (err) {
                        console.error("Payment handling failed:", err);
                    } finally {
                        setPayingId(null);
                    }
                },
                prefill: {
                    name: user.name,
                    contact: user.mobile_number,
                },
                theme: {
                    color: "#09636e",
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
            rzp.on('payment.failed', function (response) {
                console.error("Payment failed:", response.error);
                showToast(`❌ Payment Failed: ${response.error.description || 'Try again later.'}`, 'error')
            });
        } else {
            accessCard();
            accessCallReg();
        }
    };

    const handleToTopic = async (subject_code, foundItem) => {
        navigate(`/topic/${subject_code}`)
        // navigate('/topic', { state: subject_code });
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1280, 
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
        ],
    };


    return (
        <div className='feature_slider'>
            <h2>Popular Course</h2>
            <Slider {...settings}>
                {loading
                    ? Array.from({ length: 3 }).map((_, idx) => (
                        <div key={idx} className="course_card subject skeleton-cardf">
                            <div className="skeleton-boxf"></div>
                            <div className="skeleton-textf"></div>
                            <div className="skeleton-textf"></div>
                        </div>
                    ))
                    : subject.map((item) => {
                        const foundItem = (enroll ?? []).find(
                            (enrollItem) => enrollItem.subject_code === item.subject_code
                        );
                        return (
                            <div
                                key={item.subject_code}
                                className="feature_card"
                                onClick={() => handleToTopic(item.subject_code, foundItem)}
                            >
                                {item.selling_price && (
                                    <div className="course_price">
                                        {calculateDiscountPercentage(item.subject_price, item.selling_price)}% OFF
                                    </div>
                                )}
                                <img src={item.subject_image} alt={item.subject_name} />
                                <div className="card-topic">
                                    <div>{item.subject_name}</div>
                                </div>
                                <div className="feature_btn">
                                    {foundItem ? (
                                        <div className='enrolled'>Enrolled</div>
                                    ) : (
                                        <div
                                            className='pay'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handlePayment(e, item);
                                            }}
                                        >
                                            Buy Now({item.selling_price || item.subject_price}/-)
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
            </Slider>
        </div>
    );
};

export default Featured;
